export const tenantText = {
  id: 'テナントID',
  name: '会社名',
  dakokuPassword: '打刻用パスワード',
  apiPassword: 'NEO用パスワード',
  expirationDate: '有効期限',
};
